import React from "react";
import { DEFAULT_HOST_IMAGE } from "./utils/hostImages";

function PulsatingHead({ audioVolume, imageSrc = DEFAULT_HOST_IMAGE, alt = "Host" }) {
  const boundedVolume = Math.max(0, Math.min(Number(audioVolume) || 0, 100));
  const normalizedVolume = boundedVolume / 100;
  const speakingBoost = Math.pow(normalizedVolume, 1.35) * 0.18;
  const scale = 1 + (normalizedVolume * 0.12) + speakingBoost;

  return (
    <img
      src={imageSrc}
      alt={alt}
      className="pulsating-head"
      style={{
        transform: `scale(${scale})`,
        willChange: "transform",
      }}
    />
  );
}

export default PulsatingHead;
